module.exports = __webpack_public_path__ + "static/media/Orestes.99afa4b0.jpg";